import {
  API_VERSION,
  SUBSCRIPTION_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_TITLE = `${SUBSCRIPTION_SERVICE}/titles`;

export const titles = {
  getAll: async ({ filters, sort } = {}) => {
    const options = await apiOptions({
      url: `${API_TITLE}`,
      method: "get",
      filters,
      sort,
    });
    return apiRequest(options);
  },
  get: async (id) => {
    const options = await apiOptions({
      url: `${API_TITLE}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_TITLE,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_TITLE}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_TITLE}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
};
